export default "__VITE_ASSET__DLunnk_F__"